<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="模型名称" prop="modelName">
        <Input v-model="formValidate.modelName" placeholder="请输入模型名称"></Input>
      </FormItem>
      <FormItem label="显示名称" prop="showName">
        <Input v-model="formValidate.showName" placeholder="请输入显示名称"></Input>
      </FormItem>
      <FormItem label="解压路径" prop="unzipPath">
        <Input v-model="formValidate.unzipPath" placeholder="请输入解压路径"></Input>
      </FormItem>
      <FormItem label="Docker名称" prop="dockerName">
        <Input v-model="formValidate.dockerName" placeholder="请输入Docker名称"></Input>
      </FormItem>
      <FormItem label="模型文件" prop="modelDownloadUrl">
        <RadioGroup v-model="uploadType" @on-change="handleUploadTypeChange">
          <Radio label="upload">手动上传文件</Radio>
          <Radio label="url">填写文件地址</Radio>
        </RadioGroup>
        
        <!-- 手动上传文件 -->
        <div v-if="uploadType === 'upload'" style="margin-top: 10px;">
          <input 
            type="file" 
            accept=".zip" 
            @change="handleModelFileChange" 
            ref="modelFileInput"
            style="margin-bottom: 10px;"
          />
          <div v-if="showModelFileName" class="file-info">
            <Icon type="ios-document" style="margin-right: 5px;"></Icon>
            {{ showModelFileName }}
          </div>
          <div v-if="formValidate.md5" class="md5-info">
            <Icon type="ios-key" style="margin-right: 5px;"></Icon>
            <strong>MD5:</strong> {{ formValidate.md5 }}
          </div>
        </div>
        
        <!-- 填写文件地址 -->
        <div v-if="uploadType === 'url'" style="margin-top: 10px;">
          <Input 
            v-model="formValidate.modelDownloadUrl" 
            placeholder="请输入模型文件的下载地址"
            style="margin-bottom: 10px;"
          />
          <div class="url-tip">
            <Icon type="ios-information-circle" style="margin-right: 5px;"></Icon>
            请确保文件地址可正常访问
          </div>
        </div>
      </FormItem>
      <FormItem label="缺陷JSON配置" prop="flawJson">
        <input 
          type="file" 
          accept=".json" 
          @change="handleJsonFileChange" 
          ref="jsonFileInput"
          style="margin-bottom: 10px;"
        />
        <div v-if="showJsonFileName" class="file-info">
          <Icon type="ios-document" style="margin-right: 5px;"></Icon>
          {{ showJsonFileName }}
        </div>
        <div v-if="formValidate.flawJson" class="json-preview">
          <div style="margin-bottom: 5px; font-weight: bold;">JSON内容预览：</div>
          <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; max-height: 200px; overflow-y: auto;">{{ formatJson(formValidate.flawJson) }}</pre>
        </div>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import moment from 'moment';
const { v4: uuidv4 } = require('uuid');
const CryptoJS = require('crypto-js');
import { getOssClient } from '@/api/ossClient';

export default {
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      uploadType: 'upload', // 默认选择手动上传
      showModelFileName: '',
      showJsonFileName: '',
      formValidate: {
        id: '',
        modelName: '',
        showName: '',
        unzipPath: '',
        dockerName: '',
        modelDownloadUrl: '',
        flawJson: '',
        md5: ''
      },
      ruleValidate: {
        modelName: [
          {
            required: true,
            message: '模型名称必须填写',
            trigger: 'blur'
          }
        ],
        showName: [
          {
            required: true,
            message: '显示名称必须填写',
            trigger: 'blur'
          }
        ],
        unzipPath: [
          {
            required: false,
            message: '解压路径必须填写',
            trigger: 'blur'
          }
        ],
        dockerName: [
          {
            required: false,
            message: 'Docker名称必须填写',
            trigger: 'blur'
          }
        ],
        modelDownloadUrl: [
          {
            required: true,
            message: '模型文件必须上传',
            trigger: 'blur'
          }
        ],
        flawJson: [
          {
            required: true,
            message: '缺陷JSON配置文件必须上传',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    handleUploadTypeChange (value) {
      // 切换上传类型时清空相关数据
      if (value === 'url') {
        this.showModelFileName = ''
        this.formValidate.md5 = ''
        // 清空文件输入
        if (this.$refs.modelFileInput) {
          this.$refs.modelFileInput.value = ''
        }
      } else if (value === 'upload') {
        this.formValidate.modelDownloadUrl = ''
      }
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.modelName = data.modelName
      this.formValidate.showName = data.showName
      this.formValidate.unzipPath = data.unzipPath
      this.formValidate.dockerName = data.dockerName
      this.formValidate.modelDownloadUrl = data.modelDownloadUrl
      this.formValidate.flawJson = data.flawJson
      this.formValidate.md5 = data.md5 || ''
      
      // 根据现有数据判断上传类型
      if (data.modelDownloadUrl) {
        // 如果URL包含OSS域名，说明是上传的文件，否则是手动输入的URL
        if (data.modelDownloadUrl.includes('oss-cn-shenzhen.aliyuncs.com') || data.modelDownloadUrl.includes('sinano-clother')) {
          this.uploadType = 'upload'
          const modelUrlArray = data.modelDownloadUrl.split("/")
          this.showModelFileName = modelUrlArray[modelUrlArray.length - 1]
        } else {
          this.uploadType = 'url'
        }
      } else {
        this.uploadType = 'upload'
      }
      
      if (data.flawJson) {
        this.showJsonFileName = '已上传的JSON文件'
      }
    },
    async handleModelFileChange(e) {
      try {
        const file = e.target.files[0];
        if (!file) return;

        // 检查文件类型
        if (!file.name.toLowerCase().endsWith('.zip')) {
          this.$Message.error('请选择zip文件');
          return;
        }

        this.showModelFileName = file.name;
        this.formValidate.modelDownloadUrl = await this.uploadModelFile(file);
        
        if (this.formValidate.modelDownloadUrl) {
          this.$Message.success('模型文件上传成功');
        }
      } catch (error) {
        this.$Message.error('模型文件上传失败');
        console.error(error);
      }
    },
    async handleJsonFileChange(e) {
      try {
        const file = e.target.files[0];
        if (!file) return;

        // 检查文件类型
        if (!file.name.toLowerCase().endsWith('.json')) {
          this.$Message.error('请选择JSON文件');
          return;
        }

        this.showJsonFileName = file.name;
        
        // 读取JSON文件内容
        const jsonContent = await this.readJsonFile(file);
        this.formValidate.flawJson = jsonContent;
        
        this.$Message.success('JSON文件上传成功');
      } catch (error) {
        this.$Message.error('JSON文件上传失败');
        console.error(error);
      }
    },
    async uploadModelFile(file) {
      try {
        // 计算文件MD5值
        const md5 = await this.calculateMD5(file);
        
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4();
        const fileExtension = file.name.substring(file.name.lastIndexOf('.'));
        const finalZipName = uuid + fileExtension;
        
        const path = `pic/model_version/${currentDate}/${finalZipName}`;
        const client = await getOssClient();
        const result = await client.put(path, file);
        
        if (result['res']['statusCode'] == 200) {
          // 保存MD5值到表单数据中
          this.formValidate.md5 = md5;
          return result['res']['requestUrls'][0];
        } else {
          this.$Message.error('上传失败');
          return '';
        }
      } catch (error) {
        this.$Message.error('上传失败');
        console.error(error);
        return '';
      }
    },
    readJsonFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const content = e.target.result;
            // 验证JSON格式
            JSON.parse(content);
            resolve(content);
          } catch (error) {
            reject(new Error('JSON文件格式错误'));
          }
        };
        reader.onerror = () => reject(new Error('文件读取失败'));
        reader.readAsText(file);
      });
    },
    calculateMD5(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const arrayBuffer = e.target.result;
            const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);
            const md5Hash = CryptoJS.MD5(wordArray).toString();
            resolve(md5Hash);
          } catch (error) {
            reject(new Error('MD5计算失败'));
          }
        };
        reader.onerror = () => reject(new Error('文件读取失败'));
        reader.readAsArrayBuffer(file);
      });
    },
    formatJson(jsonString) {
      try {
        const obj = JSON.parse(jsonString);
        return JSON.stringify(obj, null, 2);
      } catch (error) {
        return jsonString;
      }
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 添加时移除id字段，编辑时保留id字段
          const submitData = { ...this.formValidate }
          if (!this.formValidate.id) {
            delete submitData.id
            // 添加模型时，如果解压路径和Docker名称为空，使用默认值
            if (!submitData.unzipPath) {
              submitData.unzipPath = '/home/sinano/images/triton_server/models_10.3'
            }
            if (!submitData.dockerName) {
              submitData.dockerName = 'tritonserver-gpu'
            }
          }
          this.$emit('on-ok', submitData)
        } else {
          this.$Message.error('请检查表单填写是否完整!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
      this.uploadType = 'upload' // 重置为默认的手动上传
      this.showModelFileName = ''
      this.showJsonFileName = ''
      // 清空文件输入
      if (this.$refs.modelFileInput) {
        this.$refs.modelFileInput.value = ''
      }
      if (this.$refs.jsonFileInput) {
        this.$refs.jsonFileInput.value = ''
      }
    }
  }
}
</script>

<style scoped>
.file-info {
  margin-top: 5px;
  padding: 5px 10px;
  background: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  color: #1890ff;
}

.md5-info {
  margin-top: 5px;
  padding: 5px 10px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 4px;
  color: #52c41a;
  font-size: 12px;
  word-break: break-all;
}

.json-preview {
  margin-top: 10px;
}

.url-tip {
  margin-top: 5px;
  padding: 5px 10px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  color: #fa8c16;
  font-size: 12px;
}
</style>
